module.exports = __webpack_public_path__ + "img/edit_mosaic.2cfaf30.svg";